module.exports = __webpack_public_path__ + "img/20200331144006497.2426bc74.png";